<template>
  <div v-show="recommendIsLoad" class="recommend-block">
    <h3 class="recommend-title">推薦商品</h3>
    <div class="recommend-wrap">
      <div class="recommend-slide">
        <div
          v-for="item in recommendData"
          :key="item.NineDigitsBarcode"
          class="recommend-container"
        >
          <a :href="item.Colors[0].MarketUrl">
            <img class="recommend-img img-fluid" :src="item.Colors[0].Covers[0]" :alt="item.Name" />
          </a>
          <div class="item__info">
            <p class="item__name">
              <a :href="item.Colors[0].MarketUrl"> {{ item.Name }} </a>
            </p>
            <p class="item__price">
              <span
                v-if="item.SellPrice !== item.OriginPrice || item.EventPrice > 0"
                class="item__old-price"
              >
                NT.{{ item.OriginPrice }}
              </span>
              <span>
                NT.{{
                  item.EventPrice > 0 && item.EventPrice < item.SellPrice
                    ? item.EventPrice
                    : item.SellPrice
                }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div v-if="mapRecommendShow">
        <span class="more-text">MORE</span>
        <span class="recommend-arrow-left" @click="arrowClick('left')" />
        <span class="recommend-arrow-right" @click="arrowClick('right')" />
      </div>
    </div>
  </div>
</template>

<script>
import { getSearchRecommendData } from '@global/helpers/recommend';
import { fireSearchResultRecommendEvent } from '@global/gtm/shopList/shopListView';
import $ from 'jquery';
import { createNamespacedHelpers } from 'vuex';
import { fireRecommendClickGAEvent } from '@global/gtm/product';

const { mapState } = createNamespacedHelpers('miniCartModule');

require('@global/vendors/slick');

export default {
  name: 'RecommendList',
  data() {
    return {
      nowEnv: window.nowEnv,
      recommendData: [],
      recommendIsLoad: false,
      slideOptions: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        speed: 800,
        mobileFirst: true,
        arrows: true,
        prevArrow: '.recommend-arrow-left',
        nextArrow: '.recommend-arrow-right',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3,
            },
          },
        ],
      },
      allAPILoad: {
        hotLoad: false,
        recommendIsLoad: false,
      },
    };
  },
  computed: {
    ...mapState(['hotSearch', 'hotLoad']),
    mapRecommendShow() {
      return (
        (this.recommendData.length > 2 && this.nowEnv.NowMyEquipment) ||
        (this.recommendData.length > 4 && !this.nowEnv.NowMyEquipment)
      );
    },
  },
  watch: {
    recommendIsLoad() {
      if (this.recommendData.length > 0) {
        this.$nextTick(() => {
          $('.recommend-slide').slick(this.slideOptions);
        });
      }
    },
    hotLoad() {
      this.allAPILoad.hotLoad = true;
    },
    allAPILoad: {
      deep: true,
      handler(nawValue) {
        if (nawValue.hotLoad && nawValue.recommendIsLoad) {
          fireSearchResultRecommendEvent(this.hotSearch, this.recommendData);
        }
      },
    },
  },
  created() {
    getSearchRecommendData().then((res) => {
      this.recommendData = res;
      this.recommendIsLoad = true;
      this.allAPILoad.recommendIsLoad = true;
    });
  },
  methods: {
    arrowClick(direction) {
      fireRecommendClickGAEvent({
        recommendedData: this.recommendData,
        recommendedMove: direction === 'left' ? '推薦商品 More 左箭頭' : '推薦商品 More 右箭頭',
        recommendedType: '搜尋結果頁',
        productId: '',
        productName: '',
        itemListName: '搜尋結果頁推薦商品列表',
      });
    },
  },
};
</script>
